<template>
  <div>
    <div class="bannerImg"></div>
    <div class="lable">请输入概念名称</div>

    <el-select class="input" v-model="curBkCode" filterable :filter-method="searchConcept" placeholder="搜索概念">
      <el-option v-for="item in conceptOption" :key="item.bk_code" :label="item.bk_name"
        :value="item.bk_code"></el-option>
    </el-select>

    <div class="lable">推荐概念</div>
    <a href="javascript:void(0)" v-for="item in recommendConcepts" :key="item.name">
      <div class="tag"> <el-tag @click="quikGenConcept(item.code)">{{ item.name }}</el-tag></div>
    </a>
    <div slot="footer" class="dialog-footer">
      <el-row style="clear:both;min-height:20px;text-align:left">
      </el-row>
      <el-button type="primary" @click="genConcept">开始写作</el-button>
    </div>

  </div>
</template>

<script>

// import Loading from '../components/js/Loading'
export default {
  data: function () {
    return {

      curBkCode: '',
      conceptList: [],
      conceptOption: [],

      recommendConcepts: []
    }
  },

  methods: {

    searchConcept (key) {
      this.conceptOption = []
      console.log(key)

      key = key.toUpperCase()
      for (let concept of this.conceptList) {
        if (this.conceptOption.length > 4) {
          break
        }
        if (concept.bk_code.indexOf(key) > -1 ||
          concept.bk_name.indexOf(key) > -1
        ) {
          this.conceptOption.push(concept)
        }
      }
    },

    quikGenConcept (bkCode) {
      this.conceptOption = this.conceptList
      this.curBkCode = bkCode
      this.genConcept()
    },
    genConcept () {
      this.axios.getWithLoading(`/webApi/v3/robot/stock/conceptReport?conceptCode=${this.curBkCode}`).then(resp => {
        this.$router.push({ path: '/newsEdit', query: { articleId: resp.data.autoNewsId, 'from': 'finance' } })
      }).catch(() => {
        this.conceptOption = []
      })
    }
  },
  components: {

  },
  watch: {

  },
  mounted () {
    let _this = this

    this.axios.get('/webApi/v3/finace/api_concept_list_info').then(resp => {
      _this.conceptList = resp.data
      _this.conceptOption = _this.conceptList.slice(0, 5)
    })

    this.axios.get('/webApi/v3/finace/concept_recommend').then(resp => {
      _this.recommendConcepts = resp.data
    })
  }
}
</script>
<style lang="less" scoped>
.bannerImg {
  background-image: url('../../assets/imgs/conceptBanner.png');
}
</style>



// WEBPACK FOOTER //
// src/components/write/concept.vue